var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('e-tooltip',{attrs:{"content":_vm.isCodeExpanded ? 'Shrink Code Panel' : 'Expand Code Panel'}},[_c('button',{staticClass:"e-btn e-btn-onlyicon e-btn-borderless",on:{"click":function($event){return _vm.toggleCodeExpansion()}}},[_c('e-icon',{attrs:{"icon":_vm.isCodeExpanded ? 'e-compress' : 'e-expand'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }